import React from 'react';

interface DispatchIconProps {
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

const DispatchIcon: React.FC<DispatchIconProps> = ({ size = 24, color = 'currentColor', style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    {/* Van body */}
    <rect x="1" y="11" width="14" height="8" rx="1.5" />
    {/* Van cab */}
    <path d="M15 15h3.5a1.5 1.5 0 0 0 1.2-.6L22 11.5V19h-7" />
    {/* Cargo divider line */}
    <line x1="10" y1="11" x2="10" y2="19" />
    {/* Wheels */}
    <circle cx="5" cy="19" r="1.5" />
    <circle cx="18" cy="19" r="1.5" />
    {/* Signal waves (top right of van, broadcast/dispatch) */}
    <path d="M17 3c1.1.9 2 2.3 2 4" />
    <path d="M19.5 1c1.8 1.4 3 3.6 3 6" />
    {/* Antenna dot */}
    <circle cx="15.5" cy="7" r="0.75" fill={color} stroke="none" />
  </svg>
);

export default DispatchIcon;
